/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../resources/datatypes';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "team_api": {
        "nested": {
          "RetrieveJobRequest": {
            "fields": {
              "jobId": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "RetrieveJobResponse": {
            "fields": {
              "job": {
                "type": ".squareup.team_api.Job",
                "id": 1,
                "rule": "optional"
              },
              "errors": {
                "type": ".squareup.connect.v2.resources.Error",
                "id": 2,
                "rule": "repeated"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.team_api?.nested?.RetrieveJobRequest && !$root.nested?.squareup?.nested?.team_api?.nested?.RetrieveJobResponse) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc Represents a [RetrieveJob](api-endpoint:Team-RetrieveJob) request.
 * --
 *
 * SOURCE RetrieveJobRequest @ squareup/team_api/endpoints/retrieve-job.proto at 23:1
 */
export const RetrieveJobRequest = $root.lookupType('squareup.team_api.RetrieveJobRequest');
fixType(RetrieveJobRequest, {
  jobId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(RetrieveJobRequest);
/**
 * --
 * @desc Represents a [RetrieveJob](api-endpoint:Team-RetrieveJob) response. Either `job` or `errors`
 * is present in the response.
 * --
 *
 * SOURCE RetrieveJobResponse @ squareup/team_api/endpoints/retrieve-job.proto at 36:1
 */
export const RetrieveJobResponse = $root.lookupType('squareup.team_api.RetrieveJobResponse');
fixType(RetrieveJobResponse);
Builder.createAndAttachToType(RetrieveJobResponse);